export const getWrapperStyle = (size) => ({
  position: 'relative',
  width: size,
  height: size,
})

export const timeStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
}
